export const roadA1Juan = [
    
    {
        id: 0,
        thumbnail:"https://i.ibb.co/whB5hS0B/B2-FIRST-29.png",
        title: " Antes del Curso",
        subtitle: "Centro de Clasificación ",
    
        dateAdded: "Basic 0 ",
        channel: " ",
        description: "Si has llevado clases de inglés antes realiza un examen para calcular tu nivel,Envia tu examen para su corrección al correo temis_it@hotmail.com",
        enlaces: [
            {  titulo:"Hola soy Juan!",url: "https://youtu.be/hfe0-ZFCCJg"},        

        ],
    },
    {
        id: 1,
        thumbnail:"https://i.ibb.co/whB5hS0B/B2-FIRST-29.png",
        title: " Recursos Digitales",
        subtitle: "Centro de Clasificación ",
    
        dateAdded: "Basic 0 ",
        channel: " ",
        description: "Si has llevado clases de inglés antes realiza un examen para calcular tu nivel,Envia tu examen para su corrección al correo temis_it@hotmail.com",
        enlaces: [
            {  titulo:"Guia 1",url: "https://drive.google.com/file/d/1RXkFo0gRyCUkvOmGFd_n01yQ8N_Mekza/view?usp=sharing"},        
            {  titulo:"Guia 2",url: "https://drive.google.com/file/d/1WS1TCpptgyOz6buLF_7eUi0nn5LgDujC/view?usp=sharing"},        
            {  titulo:"Guia 3",url: "https://drive.google.com/file/d/10z4cBCF_dOumKZYw6obU2OOu05euC1b7/view?usp=sharing"},        

        ],
    },
            
    {
        id: 2,
        thumbnail:"https://i.ibb.co/whB5hS0B/B2-FIRST-29.png",
        title: " Pasado Simple vs Continuo",
        subtitle: "Centro de Clasificación ",
    
        dateAdded: "Basic 0 ",
        channel: " ",
        description: "Si has llevado clases de inglés antes realiza un examen para calcular tu nivel,Envia tu examen para su corrección al correo temis_it@hotmail.com",
        enlaces: [
            {  titulo:"🎬Pasado simple y Continuo ", url: "https://youtu.be/-J2viAntb1w?si=5K2NEpOQG35Kg2Lz"}, 
          
        ],
    },
  
   
   
    {
        id: 3,
        thumbnail:"https://i.ibb.co/whB5hS0B/B2-FIRST-29.png",
        title: " Posesivos ",
        subtitle: "Centro de Clasificación ",
    
        dateAdded: "Basic 0 ",
        channel: " ",
        description: "Si has llevado clases de inglés antes realiza un examen para calcular tu nivel,Envia tu examen para su corrección al correo temis_it@hotmail.com",
        enlaces: [
            {  titulo:"🎬 Pronombres y Adjetivos Posesivos", url: "https://youtu.be/GUwql1JyDE4?si=umF5mp8kdNMjQZs0"},

            {  titulo:"🧩Possessive Pronouns", url: "https://wordwall.net/play/52592/500/1753"},
            {  titulo:"🧩Possesive Adjectives", url: "https://wordwall.net/play/55417/749/2837" },
            {  titulo:"🧩Possesive Adjectives I", url: "https://wordwall.net/play/18888/235/2402" },
        ],
    },
    {
        id: 4,
        thumbnail:"https://i.ibb.co/whB5hS0B/B2-FIRST-29.png",
        title: " Modales  ",
        subtitle: "Centro de Clasificación ",
    
        dateAdded: "Basic 0 ",
        channel: " ",
        description: "Si has llevado clases de inglés antes realiza un examen para calcular tu nivel,Envia tu examen para su corrección al correo temis_it@hotmail.com",
        enlaces: [
            {  titulo:"🎬Aprende los 3 verbos Modales", url: "https://youtu.be/Rn-bwBZ2h0g?si=DoCyFthYOQTFpVxp"},

          
        ],
    },
    {
        id: 5,
        thumbnail:"https://i.ibb.co/whB5hS0B/B2-FIRST-29.png",
        title: "VERBOS CON EL TO  ",
        subtitle: "Centro de Clasificación ",
    
        dateAdded: "Basic 0 ",
        channel: " ",
        description: "Si has llevado clases de inglés antes realiza un examen para calcular tu nivel,Envia tu examen para su corrección al correo temis_it@hotmail.com",
        enlaces: [
            {  titulo:"🎬VERBOS CON EL TO", url: "https://youtu.be/flbAgXkkFyo?si=HfpdZD-V9h2DWm4g"},
            { titulo: "🧩  Desafio gerund vs infinitive",url: "https://wordwall.net/play/7240/772/7948", },
            { titulo: "🧩  Desafio gerund vs infinitive II",url: "https://wordwall.net/play/22920/270/462", },
            { titulo: "🧩  Desafio gerund vs infinitive III",url: "https://wordwall.net/play/76232/915/656", },
            { titulo: "🧩  Desafio gerund vs infinitive IV",url: "https://wordwall.net/play/71477/712/378", },
            { titulo: "🧩  Desafio gerund vs infinitive V",url: "https://wordwall.net/play/75464/667/869", },
            { titulo: "🧩  Desafio gerund vs infinitive VI ",url: "https://wordwall.net/play/59257/372/969", },
            { titulo: "🧩  Desafio gerund vs infinitive VII ",url: "https://wordwall.net/play/4838/285/4447", },
          
        ],
    },
    {
        id: 6,
        thumbnail:"https://i.ibb.co/whB5hS0B/B2-FIRST-29.png",
        title: "El verbo Get ",
        subtitle: "Centro de Clasificación ",
    
        dateAdded: "Basic 0 ",
        channel: " ",
        description: "Si has llevado clases de inglés antes realiza un examen para calcular tu nivel,Envia tu examen para su corrección al correo temis_it@hotmail.com",
        enlaces: [
            {  titulo:"🎬 APRENDE EL VERBO GET",url: "https://youtu.be/uo9BRUaOsIc?si=GUSVcsIVw1p3FgY1"},           

          
        ],
    },
    {
        id:7,
        thumbnail:"https://i.ibb.co/whB5hS0B/B2-FIRST-29.png",
        title: "Verbos Irregulares  ",
        subtitle: "Centro de Clasificación ",
    
        dateAdded: "Basic 0 ",
        channel: " ",
        description: "Si has llevado clases de inglés antes realiza un examen para calcular tu nivel,Envia tu examen para su corrección al correo temis_it@hotmail.com",
        enlaces: [
            {  titulo:"🎬Domina los Irregular Verbs ",url: "https://youtu.be/zAhjErzZ8DQ?si=e1UETanlRRQCr3zR"},           

          
        ],
    },
    {
        id: 8,
        thumbnail:"https://i.ibb.co/whB5hS0B/B2-FIRST-29.png",
        title: "Present Simple   ",
        subtitle: "Centro de Clasificación ",
    
        dateAdded: "Basic 0 ",
        channel: " ",
        description: "Si has llevado clases de inglés antes realiza un examen para calcular tu nivel,Envia tu examen para su corrección al correo temis_it@hotmail.com",
        enlaces: [
            {  titulo:"🎬 EL PRESENTE SIMPLE  ",url: "https://youtu.be/PMYus-ErQbU?si=fsvJrq7Xmf7l9I3U"},           
            {  titulo:"[🧩 Activity] The Verb Be Affirmative Form I", url: "https://wordwall.net/play/13293/724/51767" },
            {  titulo:"[🧩 Activity] The Verb Be Affirmative Form II", url: "https://wordwall.net/play/14390/465/80013" },
            {  titulo:"[🧩 Activity] The Verb Be Affirmative Form III", url: "https://wordwall.net/play/11554/389/1088" },
          
            {  titulo:"[🧩 Activity] The Verb Be Negative Form", url: "https://wordwall.net/play/21158/025/3896" },
            {  titulo:"[🧩 Activity] The Verb Be Affirmative Form I", url: "https://wordwall.net/play/13293/724/51767" },
            {  titulo:"[🧩 Activity] The Verb Be Affirmative Form II", url: "https://wordwall.net/play/14390/465/80013" },
            {  titulo:"[🧩 Activity] The Verb Be Affirmative Form III", url: "https://wordwall.net/play/11554/389/1088" },
      
            {  titulo:"[🧩 Activity] The Verb Be Interrogative Form I", url: "https://wordwall.net/play/1856/077/57902" },
            {  titulo:"[🧩 Activity] The Verb Be Interrogative Form II", url: "https://wordwall.net/play/58086/380/593" },
            { titulo: "💡🎦 Present Tense Simple Be 01  ",url: "https://drive.google.com/file/d/1O2eE2VUMwZLRuFiDaTvjE-zTIj15DP-h/view?usp=sharing", },
            {  titulo:"[🧩 Activity] The Verb Be Negative Form", url: "https://wordwall.net/play/21158/025/3896" },

            {  titulo:"[🧩 Activity] 3rd Person Rules",url: "https://wordwall.net/play/28761/823/4170" },
            {  titulo:"[🧩 Activity] Present Simple  Affirmative Form",url: "https://wordwall.net/play/57830/431/8032" },
            { titulo: "💡🎦 Present Tense Simple 01  ",url: "https://drive.google.com/file/d/16-zgiVH0dbaoa7GqXz7gNfAQSXOOx7zl/view?usp=sharing", },
            { titulo: "💡🎦 Present Tense Simple 02  ",url: "https://drive.google.com/file/d/1UDHSqaN1269ZYDfTaet2_Cd8X2SlE-_f/view?usp=sharing", },
            { titulo: "💡🎦 Present Tense Simple 03  ",url: "https://drive.google.com/file/d/1zoXjEjhdZfGh35xQUsVQDFhBk5misIq0/view?usp=sharing", },
        ],
    },
    {
        id: 9,
        thumbnail:"https://i.ibb.co/whB5hS0B/B2-FIRST-29.png",
        title: "Comparatives And Superlatives",
        subtitle: "Centro de Clasificación ",
    
        dateAdded: "Basic 0 ",
        channel: " ",
        description: "Si has llevado clases de inglés antes realiza un examen para calcular tu nivel,Envia tu examen para su corrección al correo temis_it@hotmail.com",
        enlaces: [
            {  titulo:"🎬Comparatives And Superlatives  ",url: "https://youtu.be/Bf1jx3QCFfE?si=Lw7JN3-MGvDEnfXN"},           

          
        ],
    },
   
    {
        id: 10,
        thumbnail:"https://i.ibb.co/whB5hS0B/B2-FIRST-29.png",
        title: "FOR, BY, BECAUSE",
        subtitle: "Centro de Clasificación ",
    
        dateAdded: "Basic 0 ",
        channel: " ",
        description: "Si has llevado clases de inglés antes realiza un examen para calcular tu nivel,Envia tu examen para su corrección al correo temis_it@hotmail.com",
        enlaces: [
            {  titulo:"🎬FOR, BY, BECAUSE  ",url: "https://youtu.be/k2o7QbDNCpI?si=CJ8JpF7iKTN7iEzQ"},           

          
        ],
    },
    {
        id: 11,
        thumbnail:"https://i.ibb.co/whB5hS0B/B2-FIRST-29.png",
        title: "CÓMO USAR ALONE, ONLY, JUST.",
        subtitle: "Centro de Clasificación ",
    
        dateAdded: "Basic 0 ",
        channel: " ",
        description: "Si has llevado clases de inglés antes realiza un examen para calcular tu nivel,Envia tu examen para su corrección al correo temis_it@hotmail.com",
        enlaces: [
            {  titulo:"🎬CÓMO USAR ALONE, ONLY, JUST.  ",url: "https://youtu.be/rOySPSMZXq0?si=pA9PsX6lK-8Yt1ZV"},           

          
        ],
    },
    {
        id: 12,
        thumbnail:"https://i.ibb.co/whB5hS0B/B2-FIRST-29.png",
        title: "EL PASADO SIMPLE con EL WAS, EL WERE Y EL DID",
        subtitle: "Centro de Clasificación ",
    
        dateAdded: "Basic 0 ",
        channel: " ",
        description: "Si has llevado clases de inglés antes realiza un examen para calcular tu nivel,Envia tu examen para su corrección al correo temis_it@hotmail.com",
        enlaces: [
            {  titulo:"🎬EL PASADO SIMPLE con EL WAS, EL WERE Y EL DID ",url: "https://www.youtube.com/watch?si=TfzumhI2YhZK0oa0&v=5FJJh985OEk&feature=youtu.be"},           

            {  titulo:"🧩 Simple Past Irregular Verbs",url: "https://wordwall.net/play/15208/131/43596" },
            {  titulo:"🧩 Simple Past Irregular Verbs II",url: "https://wordwall.net/play/25350/524/3505" },
        ],
    },
    {
        id: 13,
        thumbnail:"https://i.ibb.co/whB5hS0B/B2-FIRST-29.png",
        title: "WASN'T Y EL WEREN'T",
        subtitle: "Centro de Clasificación ",
    
        dateAdded: "Basic 0 ",
        channel: " ",
        description: "Si has llevado clases de inglés antes realiza un examen para calcular tu nivel,Envia tu examen para su corrección al correo temis_it@hotmail.com",
        enlaces: [
            {  titulo:"🎬WASN'T Y EL WEREN'T ",url: "https://youtu.be/Rxh2Cevengw?si=Gh-7_K5Nn_QexW3I"},           

          
            {  titulo:"🧩 Simple Past was/were",url: "https://wordwall.net/play/62938/423/342" },
            {  titulo:"🧩 Simple Past Regular Verbs",url: "https://wordwall.net/play/15209/196/99109" },
            {  titulo:"🧩 Simple Past Complete Regular Verbs",url: "https://wordwall.net/play/7639/322/54002" },

           


            {  titulo:"🧩 Simple Past Order the",url: "https://wordwall.net/play/13891/224/58926" },

            {  titulo:"🧩 Present Perfect VS sIMPLE PAST",url: "https://wordwall.net/play/3872/569/6556" },
            {  titulo:"🧩 Present Perfect VS sIMPLE PAST II",url: "https://wordwall.net/play/3580/893/7297" },

            
        ],
    },
    {
        id: 14,
        thumbnail:"https://i.ibb.co/whB5hS0B/B2-FIRST-29.png",
        title: "APRENDE A USAR EL BEEN",
        subtitle: "Centro de Clasificación ",
    
        dateAdded: "Basic 0 ",
        channel: " ",
        description: "Si has llevado clases de inglés antes realiza un examen para calcular tu nivel,Envia tu examen para su corrección al correo temis_it@hotmail.com",
        enlaces: [
            {  titulo:"🎬APRENDE A USAR EL BEEN ",url: "https://youtu.be/WRgHtFHHJjM?si=QnTz0SlM0FNm7wCf"},           
            {
                titulo: "PRESENT PERFECT Exercises Grammar",
                url: "https://wordwall.net/play/20930/047/3447",
            },

            {
                titulo: "Since and for",
                url: "https://wordwall.net/play/22172/068/39116",
            },
            
         
          
        ],
    },
    {
        id: 14,
        thumbnail:"https://i.ibb.co/whB5hS0B/B2-FIRST-29.png",
        title: "APRENDE A USAR EL BEEN",
        subtitle: "Centro de Clasificación ",
    
        dateAdded: "Basic 0 ",
        channel: " ",
        description: "Si has llevado clases de inglés antes realiza un examen para calcular tu nivel,Envia tu examen para su corrección al correo temis_it@hotmail.com",
        enlaces: [
            {  titulo:"🎬APRENDE A USAR EL BEEN ",url: "https://youtu.be/WRgHtFHHJjM?si=QnTz0SlM0FNm7wCf"},           
            {
                titulo: "PRESENT PERFECT Exercises Grammar",
                url: "https://wordwall.net/play/20930/047/3447",
            },

            {
                titulo: "Since and for",
                url: "https://wordwall.net/play/22172/068/39116",
            },
            
         
          
        ],
    },
   


   
];
